export default {
}



// WEBPACK FOOTER //
// ./src/app/dweller/meeting/details/resources/computed.js